import _assign from "object-assign";
import { fade } from '@material-ui/core/styles';
var multilinePadding = {
  touch: {
    top: 12,
    bottom: 11
  },
  low: {
    top: 10,
    bottom: 8
  },
  medium: {
    top: 6,
    bottom: 6
  },
  high: {
    top: 3,
    bottom: 3
  }
};
var multilineFieldPadding = {
  touch: {
    top: 12,
    bottom: 8
  },
  low: {
    top: 9,
    bottom: 7
  },
  medium: {
    top: 6,
    bottom: 6
  },
  high: {
    top: 3,
    bottom: 2
  }
};
var buttonOffsets = {
  touch: 4,
  low: 4,
  medium: 2,
  high: 2
};
var formInputBottomPadding = {
  touch: 0,
  low: 1,
  medium: 0,
  high: 1
}; // TODO: I suspect there's a very basic default text characteristic we can refactor out of this to be reused here and elsewhere

var densityToTypeSizePaletteIndex = {
  touch: 70,
  low: 60,
  medium: 50,
  high: 40
};
export var style = function style(_ref) {
  var toolkitTheme = _ref.toolkit;
  var typography = toolkitTheme.typography,
      _toolkitTheme$palette = toolkitTheme.palette,
      type = _toolkitTheme$palette.type,
      blue30 = _toolkitTheme$palette.blue30,
      blue700 = _toolkitTheme$palette.blue700,
      grey70 = _toolkitTheme$palette.grey70,
      grey200 = _toolkitTheme$palette.grey200,
      grey900 = _toolkitTheme$palette.grey900,
      white = _toolkitTheme$palette.white,
      getDisabled = toolkitTheme.disabled.getDisabled,
      getFocusable = toolkitTheme.focusable.getFocusable,
      getSize = toolkitTheme.size.getSize,
      spacing = toolkitTheme.spacing;

  var createDensityStyle = function createDensityStyle(density) {
    var spacingMixin = spacing[density].spacing;

    var _getSize = getSize({
      density: density
    }),
        minHeight = _getSize.height;

    var padding = spacingMixin(1);
    return _assign({
      minHeight: minHeight,
      '& $input': {
        minHeight: minHeight
      },
      '&$multiline $prefixContainer': {
        height: minHeight
      },
      padding: spacingMixin(0, 1, 0, 1),
      color: type === 'dark' ? white : grey900,
      letterSpacing: 0,
      fontSize: typography.size[densityToTypeSizePaletteIndex[density]],
      lineHeight: typography.lineHeight
    }, typography.getFace(), {
      '&$field $input': {
        paddingBottom: formInputBottomPadding[density],
        minHeight: minHeight - formInputBottomPadding[density]
      },
      '&$field&$multiline $input': {
        paddingTop: multilineFieldPadding[density].top,
        paddingBottom: multilineFieldPadding[density].bottom
      },
      '&$multiline $input': {
        paddingTop: multilinePadding[density].top,
        paddingBottom: multilinePadding[density].bottom
      },
      '&$startAdornment': {
        '& $input': {
          paddingLeft: spacingMixin(1)
        },
        paddingLeft: 0
      },
      '&$endAdornment': {
        '& $input': {
          paddingRight: spacingMixin(1)
        },
        paddingRight: 0
      },
      '& button': {
        height: minHeight - buttonOffsets[density] * 2,
        margin: buttonOffsets[density],
        padding: [[0, padding - buttonOffsets[density]]]
      },
      '& ::slotted(jpm-ui-static-input-adornment)': {
        display: 'flex',
        alignItems: 'center'
      },
      '& $suffixContainer ::slotted(jpm-ui-static-input-adornment)': {
        paddingRight: spacingMixin(1)
      },
      '& $prefixContainer ::slotted(jpm-ui-static-input-adornment)': {
        paddingLeft: spacingMixin(1)
      },
      // For IE11
      '& jpm-ui-static-input-adornment': {
        display: 'flex',
        alignItems: 'center'
      },
      '& $suffixContainer jpm-ui-static-input-adornment': {
        paddingRight: spacingMixin(1)
      },
      '& $prefixContainer jpm-ui-static-input-adornment': {
        paddingLeft: spacingMixin(1)
      }
    });
  };

  var disabledStyles = getDisabled();
  var selectionBackgroundColor = type === 'light' ? blue30 : blue700; // Browsers add transparency to the colour by default this prevents that

  var selectionBackground = fade(selectionBackgroundColor, 0.99);
  return {
    root: {
      boxSizing: 'border-box',
      '& ::-ms-clear': {
        display: 'none'
      },
      display: 'inline-flex',
      alignItems: 'center',
      height: '100%',
      width: '100%',
      minWidth: '8em',
      '&$field': {
        width: '100%'
      },
      '& $input$disabled': _assign({}, disabledStyles)
    },
    input: {
      overflow: 'hidden',
      padding: 0,
      height: '100%',
      flex: 1,
      '&::selection': {
        backgroundColor: selectionBackground
      }
    },
    endAdornment: {},
    startAdornment: {},
    field: {},
    multiline: {
      alignItems: 'flex-start',
      '& $suffixContainer': {
        marginTop: 'auto'
      }
    },
    inputMultiline: {
      boxSizing: 'border-box',
      overflow: 'visible',
      verticalAlign: 'middle',
      whiteSpace: 'pre-wrap'
    },
    centerTextAlign: {
      '& $input': {
        textAlign: 'center'
      }
    },
    leftTextAlign: {
      '& $input': {
        textAlign: 'left'
      }
    },
    rightTextAlign: {
      '& $input': {
        textAlign: 'right'
      }
    },
    suffixContainer: {
      display: 'flex'
    },
    prefixContainer: {
      display: 'flex'
    },
    focused: getFocusable(),
    readOnly: {},
    disabled: {
      '&$root': {
        color: type === 'dark' ? white : grey900
      }
    },
    emptyReadOnly: {
      '&$root': {
        color: type === 'dark' ? grey70 : grey200
      }
    },
    touchDensity: createDensityStyle('touch'),
    lowDensity: createDensityStyle('low'),
    mediumDensity: createDensityStyle('medium'),
    highDensity: createDensityStyle('high')
  };
};
export var staticAdornmentStyle = function staticAdornmentStyle(_ref2) {
  var toolkitTheme = _ref2.toolkit;
  var spacing = toolkitTheme.spacing;

  var createDensityStyle = function createDensityStyle(density) {
    var spacingMixin = spacing[density].spacing;
    return {
      '&$suffix': {
        paddingRight: spacingMixin(1)
      },
      '&$prefix': {
        paddingLeft: spacingMixin(1)
      }
    };
  };

  return {
    root: {
      display: 'flex',
      alignItems: 'center'
    },
    prefix: {},
    suffix: {},
    touchDensity: createDensityStyle('touch'),
    lowDensity: createDensityStyle('low'),
    mediumDensity: createDensityStyle('medium'),
    highDensity: createDensityStyle('high')
  };
};